import React, { useState, useEffect } from "react";
import {
    Box,
    Grid,
    Button,
    TextField,
    Typography,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Autocomplete,
} from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import axios from "../../../lib/axios";
import CustomAutocomplete from '../../AutoComplete/AutoComplete';
import axiosInstance from "../../../lib/axios";

const CreditStep1 = ({
    onResidentsLoad,
    AllTextDisabled,
    AllButtonDisabled,
    setAllButtonDisabled,
    formData,
    setFormData,
    handleCancel,
    fetchRefundData,
    CnId,
    handleStepClick,
    setCnId,
}) => {
    const [bankData, setBankData] = useState([]);
    const [residents, setResidents] = useState([]);
    const [propertyData, setPropertyData] = useState([]);
    const currentDate = new Date().toISOString().split("T")[0];
    const UserId = sessionStorage.getItem('UserId');
    console.log('formData1', formData)
    useEffect(() => {
        if (!formData.Pyttype) {
            setFormData((prevState) => ({
                ...prevState,
                Pyttype: "Cash",
            }));
        }
    }, [formData, setFormData]);

    useEffect(() => {
    if (formData.CnAmt && formData.AgstBill !== undefined) {
        const cnAmt = parseFloat(formData.CnAmt) || 0;
        const agstBill = parseFloat(formData.AgstBill) || 0;

        const onacAmt = cnAmt - agstBill;
        setFormData((prevData) => ({
            ...prevData,
            OnacAmt: isNaN(onacAmt) ? 0 : onacAmt.toFixed(2),
            OnacBal: isNaN(onacAmt) ? 0 : onacAmt.toFixed(2),
        }));
    }
}, [formData.CnAmt, formData.AgstBill, setFormData]);

    useEffect(() => {
        if (bankData.length > 0) {
            setFormData((prevState) => ({
                ...prevState,
                AccLedId: formData.AccLedId,
            }));
        }
    }, [formData.Pyttype, bankData, setFormData]);

    const handleFieldChange = (field) => (event) => {
        const { value } = event.target;
        setFormData({
            ...formData,
            [field]: value,
        });
    };

    useEffect(() => {
        const fetchPropertyData = async () => {
            try {
                const response = await axios.post(
                    `PropertyMst/GetPropertyMstUserwisedrp`,
                    {
                        UserId,
                        Flag: ""
                    }
                );
                if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                    setPropertyData(response.data.Data);
                    if (response.data.Data.length > 0 && !formData.PropId) {
                        setFormData((prevState) => ({
                            ...prevState,
                            PropId: response.data.Data[0].Id.toString(),
                        }));
                    }
                } else {
                    toast.error('Failed to fetch Property');
                }
            } catch (error) {
                toast.error('Error fetching Property. Please try again.');
            }
        };

        fetchPropertyData();
    }, [formData.PropId, setFormData]);

    useEffect(() => {
        const fetchResident = async () => {
            try {
                const response = await axiosInstance.post("ResidentMst/getAllResidentMstDashBoard", {
                    start: 1,
                    PageSize: 1,
                    SearchText: "drp",
                });
                if (response && response.data && Array.isArray(response.data.Data)) {
                    setResidents(response.data.Data);
                    onResidentsLoad(response.data.Data);
                } else {
                    toast.info("No residents data found or invalid response format");
                }
            } catch (error) {
                toast.error("Error while fetching resident");
            }
        };
        fetchResident();
    }, []);

    useEffect(() => {
        const fetchBankDetails = async () => {
            try {
                const response = await axiosInstance.post("AccLed/GetAccLedDrp");
                if (response && response.data && Array.isArray(response.data.Data)) {
                    setBankData(response.data.Data);
                } else {
                    toast.info("No bank data found or invalid response format");
                }
            } catch (error) {
                toast.error("Error while fetching bank dropdown");
            }
        };
        fetchBankDetails();
    }, []);



    const handleInputChange = (event, newValue) => {
        if (event && event.target) {
            const { name, value } = event.target;
            let processedValue = value;
            if (name === "CnDt" || name === "ChqDt") {
                processedValue = value ? moment(value).format("YYYY-MM-DD") : "";
            }
             let finalValue = value;
        if (name === "CnAmt") {
            const numValue = parseFloat(value) || 0;
            finalValue = numValue;
            
            const agstBill = parseFloat(formData.AgstBill) || 0;
            const onacAmt = numValue - agstBill;
            
            setFormData({
                ...formData,
                [name]: finalValue,
                OnacAmt: isNaN(onacAmt) ? 0 : onacAmt.toFixed(2),
                OnacBal: isNaN(onacAmt) ? 0 : onacAmt.toFixed(2),
            });
            return;
        }
        
        setFormData({
            ...formData,
            [name]: finalValue,
        });

        } else if (newValue) {
            setFormData({
                ...formData,
                ChkOutStlNo: newValue.ChkOutStlNo,
                ChkOutStlId: newValue.ChkOutStlId.toString(),
                PropId: newValue.PropId,
                PytVchrRef: newValue.Name,
            });
        } else {
            setFormData({
                ...formData,
                ChkOutStlNo: "",
                ChkOutStlId: "",
            });
        }
    };

    const handleNextButtonClick = () => {
        const missingFields = [];
            if (!formData.AccLedId) missingFields.push("Our Bank/Ledger");
        if (!formData.ResidentId) missingFields.push("Resident/Corporate");
        if (!formData.PropId || formData.PropId === "") missingFields.push("Property");
        if (missingFields.length > 0) {
            const missingFieldsMessage = missingFields.join(", ");
            toast.error(`Please fill the mandatory fields: ${missingFieldsMessage}.`);
            return;
        }
        handleStepClick(1);
    };

    useEffect(() => {
        if (formData.PytAmt && formData.AgstBill) {
            const onacAmt = parseFloat(formData.PytAmt) - parseFloat(formData.AgstBill);
            setFormData((prevData) => ({
                ...prevData,
                OnacAmt: isNaN(onacAmt) ? "" : onacAmt?.toFixed(2),
            }));
        }
    }, [formData.PytAmt, formData.AgstBill, setFormData]);

    return (
        <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} md={10}>
                <Box display="flex" flexDirection="column" gap={1}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6} md={4}>
                            <CustomAutocomplete
                                options={propertyData}
                                id="PropId-autocomplete"
                                name="PropId"
                                label={
                                    <span>
                                        Property<span style={{ color: "red" }}>*</span>
                                    </span>
                                }
                                value={propertyData.find((prop) => prop.Id === parseInt(formData.PropId)) || null}
                                onChange={handleInputChange}
                                disabled={AllTextDisabled}
                                getOptionLabel={(option) => option.Name || ""}
                                isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                variant='filled'
                                className='custom-textfield'
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                value={formData.CnNo || ""}
                                label="Credit  No"
                                variant="filled"
                                className="custom-textfield"
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label="Credit Date"
                                name="CnDt"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                variant="filled"
                                className="custom-textfield"
                                disabled={AllTextDisabled}
                                value={formData.CnDt || currentDate}
                                onChange={handleInputChange}
                                InputProps={{
                                    inputProps: {
                                        max: currentDate,
                                    },
                                }}
                            />
                        </Grid>

                        {/* Resident/Corporate, Resident Mobile, Ref_No */}
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl variant="filled" fullWidth className="custom-select">
                                <Autocomplete
                                    id="ResidentId"
                                    name="ResidentId"
                                    value={residents.find((resident) => resident.ResidentId === formData.ResidentId) || null}
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            handleFieldChange("ResidentId")({ target: { value: newValue.ResidentId } });
                                        }
                                    }}
                                    options={residents}
                                    getOptionLabel={(option) => `${option.Name}`}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={<>Resident/Corporate <span style={{ color: "red" }}>*</span></>}
                                            variant="filled"
                                            fullWidth
                                        />
                                    )}
                                    disabled={AllTextDisabled}
                                    className="custom-textfield"
                                    isOptionEqualToValue={(option, value) => option.ResidentId === value.ResidentId}
                                    disableClearable
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl variant="filled" fullWidth className="custom-select">
                                <Autocomplete
                                    id="ResidentMobile"
                                    name="ResidentMobile"
                                    value={residents.find((resident) => resident.ResidentId === formData.ResidentId) || null}
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            handleFieldChange("ResidentId")({ target: { value: newValue.ResidentId } });
                                        }
                                    }}
                                    options={residents}
                                    getOptionLabel={(option) => `${option.Mobile}`}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Mobile" variant="filled" fullWidth />
                                    )}
                                    disabled={AllTextDisabled}
                                    className="custom-textfield"
                                    isOptionEqualToValue={(option, value) => option.ResidentId === value.ResidentId}
                                    disableClearable
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label={<span>Ref No</span>}
                                name="PytVchrRef"
                                variant="filled"
                                className="custom-textfield"
                                disabled={AllTextDisabled}
                                value={formData.PytVchrRef || ""}
                                onChange={handleInputChange}
                            />
                        </Grid>


                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl variant="filled" fullWidth className="custom-select">
                                <InputLabel id="AccLedId-select-label">
                                    Our Bank/Ledger <span style={{ color: "red" }}>*</span>
                                </InputLabel>
                                <Select
                                    labelId="AccLedId-select-label"
                                    id="AccLedId"
                                    name="AccLedId"
                                    value={formData.AccLedId || ""}
                                    onChange={handleFieldChange("AccLedId")}
                                    className="custom-textfield"
                                    disabled={AllTextDisabled}
                                >
                                    {
                                         bankData
                                            .map((bank) => (
                                                <MenuItem key={bank.AccLedId} value={bank.AccLedId}>
                                                    {bank.AccLedName}
                                                </MenuItem>
                                            ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label={<span>Credit Amount </span>}
                                name="CnAmt"
                                variant="filled"
                                className="custom-textfield"
                                disabled={AllTextDisabled}
                                value={formData.CnAmt || ""}
                                onChange={handleInputChange}
                                type="number"
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label="Against Bill Amount"
                                name="AgstBill"
                                variant="filled"
                                className="custom-textfield"
                                disabled
                                value={formData.AgstBill !== undefined && formData.AgstBill !== null ? formData.AgstBill : ""}
                                onChange={handleInputChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label="On Account"
                                name="OnacAmt"
                                variant="filled"
                                className="custom-textfield"
                                disabled
                                value={formData.OnacAmt !== undefined && formData.OnacAmt !== null ? formData.OnacAmt : ""}
                                onChange={handleInputChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                fullWidth
                                label="On Account Balance"
                                name="OnacBal"
                                variant="filled"
                                className="custom-textfield"
                                disabled
                                value={formData.OnacBal !== undefined && formData.OnacBal !== null ? formData.OnacBal : ""}
                                onChange={handleInputChange}
                            />
                        </Grid>

                        {/* Remark */}
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={<span>Remark</span>}
                                name="Remark"
                                variant="filled"
                                className="custom-textfield"
                                disabled={AllTextDisabled}
                                value={formData.Remark || ""}
                                onChange={handleInputChange}
                            />
                        </Grid>
                    </Grid>

                    {/* Form Buttons */}
                    <Grid item xs={12} className="form_button" >
                        <Button
                            variant="contained"
                            size="small"
                            sx={{
                                mr: 1,
                                background: "#064c97ff",
                                color: '#fff'
                            }}
                            disabled={AllTextDisabled}
                            onClick={handleNextButtonClick}
                        >
                            Next
                        </Button>

                        <Button
                            variant="contained"
                            size="small"
                            disabled={AllTextDisabled}
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    );
};

export default CreditStep1;